import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2023-10-27
 * @author Patrik Harag
 */
export default class ComponentOptionsCeil {

    /** @type {function(boolean)} */
    #refreshFunction;
    /** @type {boolean} */
    #checked = false;

    /**
     *
     * @param refreshFunction {function(boolean)}
     */
    constructor(refreshFunction) {
        this.#refreshFunction = refreshFunction;
    }

    createNode() {
        let toggleButton = DomBuilder.bootstrapToggleButton(' ,00', 'btn-secondary', this.#checked, b => {
            this.#checked = b;
            this.#refreshFunction(b);
        });

        return DomBuilder.div({ class: 'ceil-component' }, toggleButton);
    }

    isSelected() {
        return this.#checked;
    }
}